module.exports = __webpack_public_path__ + "img/insiderpages.fda3bed9.svg";